module.exports = __webpack_public_path__ + "img/Header_Desktop_Logo.dc416aff.png";